import type { QueryClient } from '@tanstack/react-query';

/**
 * Thời gian giữ cache cho danh mục tĩnh.
 *
 * Chỉ áp cho dữ liệu đổi DUY NHẤT qua mutation trong app — mutation nào cũng đã
 * `invalidateQueries`, nên người dùng tự sửa là thấy ngay. Trường hợp lệch còn
 * lại chỉ là người khác sửa cùng lúc, hiếm và không gây sai số liệu tiền bạc.
 */
export const CATALOG_STALE_TIME = 5 * 60_000;

/**
 * Danh mục tĩnh — đổ vào `<Select>` ở hầu hết form, mở Drawer nào cũng mount.
 * Không giữ cache thì mỗi lần mở form là một lượt tải lại toàn bộ danh mục.
 *
 * Cố ý KHÔNG có ở đây: `ecom-channels`, `live-sessions`, `product-rates` — dữ
 * liệu đổi từ nguồn ngoài app (sàn TMĐT, giá vàng), mutation invalidate không
 * cứu được nên phải kiểm tra lại mỗi lần mount.
 */
const CATALOG_QUERY_ROOTS: readonly (readonly string[])[] = [
  ['warehouses'],
  ['brands'],
  ['categories'],
  ['suppliers'],
  ['metal-categories'],
  ['labels'],
  ['b2b-settings'],
  // Nhánh con, KHÔNG lấy cả ['settings'] — nhánh đó còn chứa danh sách
  // masterdata AMIS vốn do job nền ghi vào, phải luôn tươi.
  ['settings', 'integrations'],
  ['commission', 'general-config'],
];

/**
 * Chính sách cache theo nhóm dữ liệu, khai báo tập trung tại một chỗ.
 *
 * Mặc định của `QueryClient` là `staleTime: 0` — mọi dữ liệu nghiệp vụ được
 * kiểm tra lại khi mount. Trước đây default là 5 phút cho toàn bộ 600+ query,
 * nên chuyển menu không hề gọi lại API và người dùng phải F5 mới thấy dữ liệu
 * mới. Ngoại lệ giữ cache phải khai báo tường minh ở đây, không rải rác.
 */
export function applyQueryDefaults(queryClient: QueryClient): void {
  for (const root of CATALOG_QUERY_ROOTS) {
    queryClient.setQueryDefaults([...root], { staleTime: CATALOG_STALE_TIME });
  }
}
